export default {
    title: "طلبات الاتصال",
    subtitle: "إدارة الاستفسارات الواردة من نموذج الاتصال بالموقع",
    view: "عرض الطلب",
    delete: "حذف الطلب",
    table: {
        name: "الاسم",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        subject: "الموضوع",
        message: "الرسالة",
        status: "الحالة",
        createdAt: "تاريخ الاستلام",
        actions: "الإجراءات"
    },
    status: {
        read: "تمت القراءة",
        unread: "غير مقروء"
    },
    breadcrumbs: {
        contactRequests: "طلبات الاتصال"
    },
    messages: {
        fetchError: "فشل في جلب طلبات الاتصال",
        deleteConfirm: "هل أنت متأكد أنك تريد حذف هذا الاستفسار؟",
        deleteSuccess: "تم حذف طلب الاتصال بنجاح",
        deleteError: "فشل في حذف طلب الاتصال",
        noRequests: "لم يتم العثور على طلبات اتصال"
    }
};
